"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Images_1 = require("../Images");
var styles_1 = require("./styles");
var HEADING_LEVEL = {
    '1': '4',
    '2': '5',
};
var BODY_LEVEL = {
    '1': '3',
    '2': '4',
};
var LoadingItem = function (_a) {
    var _b = _a.title, title = _b === void 0 ? 'Lorem ipsum dolor sit amet' : _b, _c = _a.subtitle, subtitle = _c === void 0 ? 'For selecting colors quickly, one of my favorite tools is ColorSnapper. You can set up a quick shortcut (cmd+shift+c) to pop open a loupe and find the hex value of a particular color.' : _c, _d = _a.level, level = _d === void 0 ? '1' : _d, _e = _a.color, color = _e === void 0 ? 'GREY_20' : _e, _f = _a.imageAspectRatio, imageAspectRatio = _f === void 0 ? '16:9' : _f;
    return (react_1.default.createElement(styles_1.Wrapper, null,
        react_1.default.createElement(Images_1.Img, { src: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", aspectRatio: imageAspectRatio, backgroundColor: color, isRounded: true }),
        react_1.default.createElement("div", null,
            react_1.default.createElement(styles_1.FakeHeading, { level: HEADING_LEVEL[level], color: color }, title)),
        react_1.default.createElement("div", null,
            react_1.default.createElement(styles_1.FakeBody, { level: BODY_LEVEL[level], color: color }, subtitle))));
};
exports.default = LoadingItem;
